import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from "@ngrx/store";
import {
  ACQUISITION_GENERIC_FEATURE_KEY,
  ACQUISITION_GENERIC_PARCEL_FEATURE_KEY,
  ACQUISITION_GENERIC_ADDRESS_BOOK_FEATURE_KEY,
  ACQUISITION_GENERIC_TITLE_REGISTER_FEATURE_KEY,
  ACQUISITION_GENERIC_STORAGE_LOCATION_FEATURE_KEY,
  ACQUISITION_GENERIC_ASSET_LOCATION_FEATURE_KEY,
  ACQUISITION_GENERIC_LESSOR_REPRESENTATIVE_FEATURE_KEY,
  ACQUISITION_GENERIC_LESSOR_STAKEHOLDER_FEATURE_KEY,
  ACQUISITION_GENERIC_INDIVIDUAL_ACREAGES_FEATURE_KEY,
  ACQUISITION_GENERIC_LESSORS_FEATURE_KEY,
  ACQUISITION_GENERIC_LESSOR_INFO_FEATURE_KEY,
  ACQUISITION_GENERIC_LESSOR_AREA_MAKER_FEATURE_KEY,
  ACQUISITION_GENERIC_CREATED_USER_FEATURE_KEY,
  ACQUISITION_GENERIC_MODIFY_USER_FEATURE_KEY,
  GenericState,
  GenericPartialState,
  GenericAdapter,
  UploadStatus,
} from "./acquisition-generic.reducer";

// Lookup the 'Acquisition' feature state managed by NgRx
export const getGenericState = createFeatureSelector<
  GenericPartialState,
  GenericState
>(ACQUISITION_GENERIC_FEATURE_KEY);

export const getGenericStateLandParcel = createFeatureSelector<
  GenericPartialState,
  GenericState
>(ACQUISITION_GENERIC_PARCEL_FEATURE_KEY);

export const getGenericStateAddressBook = createFeatureSelector<
  GenericPartialState,
  GenericState
>(ACQUISITION_GENERIC_ADDRESS_BOOK_FEATURE_KEY);

export const getGenericStateTitleRegister = createFeatureSelector<
  GenericPartialState,
  GenericState
>(ACQUISITION_GENERIC_TITLE_REGISTER_FEATURE_KEY);

export const getGenericStateStorageLocation = createFeatureSelector<
  GenericPartialState,
  GenericState
>(ACQUISITION_GENERIC_STORAGE_LOCATION_FEATURE_KEY);

export const getGenericStateAssetLocation = createFeatureSelector<
  GenericPartialState,
  GenericState
>(ACQUISITION_GENERIC_ASSET_LOCATION_FEATURE_KEY);

export const getGenericStateLessorRepresentative = createFeatureSelector<
  GenericPartialState,
  GenericState
>(ACQUISITION_GENERIC_LESSOR_REPRESENTATIVE_FEATURE_KEY);

export const getGenericStateLessorStakeholder = createFeatureSelector<
  GenericPartialState,
  GenericState
>(ACQUISITION_GENERIC_LESSOR_STAKEHOLDER_FEATURE_KEY);

export const getGenericStateIndividualAcreages = createFeatureSelector<
  GenericPartialState,
  GenericState
>(ACQUISITION_GENERIC_INDIVIDUAL_ACREAGES_FEATURE_KEY);

export const getGenericStateLessors = createFeatureSelector<
  GenericPartialState,
  GenericState
>(ACQUISITION_GENERIC_LESSORS_FEATURE_KEY);

export const getGenericStateLessorInfo = createFeatureSelector<
  GenericPartialState,
  GenericState
>(ACQUISITION_GENERIC_LESSOR_INFO_FEATURE_KEY);

export const getGenericStateLessorAreaMaker = createFeatureSelector<
  GenericPartialState,
  GenericState
>(ACQUISITION_GENERIC_LESSOR_AREA_MAKER_FEATURE_KEY);

export const getGenericStateCreatedUser = createFeatureSelector<
  GenericPartialState,
  GenericState
>(ACQUISITION_GENERIC_CREATED_USER_FEATURE_KEY);

export const getGenericStateModifyUser = createFeatureSelector<
  GenericPartialState,
  GenericState
>(ACQUISITION_GENERIC_MODIFY_USER_FEATURE_KEY);

const { selectAll, selectEntities } = GenericAdapter.getSelectors();

export function switchStateSlice(type): any {
  if (type === "LandParcel") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStateLandParcel;
  }

  if (type === "AddressBook") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStateAddressBook;
  }

  if (type === "TitleRegister") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStateTitleRegister;
  }

  if (type === "StorageLocation") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStateStorageLocation;
  }

  if (type === "LessorRepresentative") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStateLessorRepresentative;
  }

  if (type === "LessorStakeholder") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStateLessorStakeholder;
  }

  if (type === "IndividualAcreages") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStateIndividualAcreages;
  }

  if (type === "StateLessors") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStateLessors;
  }

  if (type === "LessorInfo") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStateLessorInfo;
  }

  if (type === "LessorAreaMaker") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStateLessorAreaMaker;
  }
  if (type === "AssetLocation") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStateAssetLocation;
  }
  if (type === "CreatedUser") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStateCreatedUser;
  }
  if (type === "ModifyUser") {
    // console.log("Type Passed in Selector Function", type);
    return getGenericStateModifyUser;
  }

  //  if(type === 'AccountableFunction')
  //  {
  //   console.log('Type Passed in Selector Function',type )
  //    return getGenericStateAccountableFunction;
  //  }
}

export const getAllGeneric = (type) => {
  // console.log("Type Passed in Selector 2", type);

  return createSelector(
    switchStateSlice(type),
    (state: GenericState) => selectAll(state),
  );
};

export const loadingGeneric = (type) => {
 return createSelector(
  switchStateSlice(type),
  (state: GenericState) => state.loaded,
);
}

// export const getAllGenericById = (type, id) => {
//   console.log("Type Passed in Selector 2", type);

//   return createSelector(
//     switchStateSlice(type),
//     (state: GenericState) => selectAll(state),
//   );
// };


export const getGenericError = createSelector(
  getGenericState,
  (state: GenericState) => state.error,
);

// export const loadingGeneric = createSelector(
//   getGenericState,
//   (state: GenericState) => state.loaded,
// );

export const getGenericEntities = createSelector(
  getGenericState,
  (state: GenericState) => selectEntities(state),
);

export const getSelectedId = createSelector(
  getGenericState,
  (state: GenericState) => state.selectedId,
);

export const getSelected = createSelector(
  getGenericEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId],
);

const getError = (state: GenericState): string => state.error;

const getStarted = (state: GenericState): boolean =>
  state.status === UploadStatus.Started;

const getRequested = (state: GenericState): boolean =>
  state.status === UploadStatus.Requested;

const getReady = (state: GenericState): boolean =>
  state.status === UploadStatus.Ready;

const getProgress = (state: GenericState): number => state.progress;

const getInProgress = (state: GenericState): boolean =>
  state.status === UploadStatus.Started && state.progress >= 0;

const getFailed = (state: GenericState): boolean =>
  state.status === UploadStatus.Failed;

const getCompleted = (state: GenericState): boolean =>
  state.status === UploadStatus.Completed;

export const selectUploadFileError: MemoizedSelector<
  object,
  string
> = createSelector(
  getGenericState,
  getError,
);

export const selectUploadFileReady: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getGenericState,
  getReady,
);

export const selectUploadFileRequested: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getGenericState,
  getRequested,
);

export const selectUploadFileStarted: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getGenericState,
  getStarted,
);

export const selectUploadFileProgress: MemoizedSelector<
  object,
  number
> = createSelector(
  getGenericState,
  getProgress,
);

export const selectUploadFileInProgress: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getGenericState,
  getInProgress,
);

export const selectUploadFileFailed: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getGenericState,
  getFailed,
);

export const selectUploadFileCompleted: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getGenericState,
  getCompleted,
);
